import React from 'react';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../../../components/ActionsVisibilityContext';
import { BuilderFilterFieldsHighlighted } from '../../../../components/Builder/BuilderFields/BuilderFilterFields';
import { IRowMeta } from '../../../../redux/slices/oldBuilder';
import { IFilterFieldsFragment } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  rowMeta: IRowMeta;
  filter: IFilterFieldsFragment;
}

const PredictionEventFilters = ({ rowMeta, filter }: IProps) => {
  const { showActions, hideActions } = useActionsVisibilityContext();

  return (
    <div onMouseEnter={showActions} onMouseLeave={hideActions}>
      <BuilderFilterFieldsHighlighted rowMeta={rowMeta} filter={filter} />
    </div>
  );
};

export default withActionsVisibilityContext(PredictionEventFilters);
